module.exports = __webpack_public_path__ + "angular/components/admin/dataRights-75a3124b.html";


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/dataRights.html
// module id = 49
// module chunks = 0